import { DocumentNode, OperationVariables, QueryHookOptions, QueryResult, useQuery } from "@apollo/client"


export const useBackendQuery = <TData = any, TVariables = OperationVariables>(query: DocumentNode, options?: QueryHookOptions<TData, TVariables>): QueryResult<TData, TVariables> => {
  return useQuery(query, { ...options, context: { ...options?.context, clientName: "backend" } })
}
